import { createReducer, onSuccess } from 'actionware';
import { createState } from 'stateware';
import { push } from 'connected-react-router';

import { 
  toggleTransactionModal,
  transactionModalDetail,
  getLenders,
  getTransactions,
  topup,
  withdraw,
  setLenderSelected,
  resetTransaction
} from './transactionActions';

const initialState = createState({
  showingTransactionModal: false,
  lenders: [],
  transactions: null,
  lenderSelected: null
});

export default createReducer(initialState)
.on(toggleTransactionModal, (state, action) => {
    return initialState.copy({
      ...state,
      showingTransactionModal: !state.showingTransactionModal,
      action
    });
  })
.on(transactionModalDetail, (state, content) => {
    return initialState.copy({
      ...state,
      modalContent: content
    });
  })
.on(getLenders, (state, action) => {
    return initialState.copy({
      ...state,
      lenders: action
    });
  })
.on(getTransactions, (state, {lists, summary, totalData}) => {
    return initialState.copy({
      ...state,
      transactions: lists,
      summary,
      totalData
    })
  })
.on(resetTransaction, () => {
    return initialState
})
.on(setLenderSelected, (state, lenderId) => {
    return initialState.copy({
      ...state,
      lenderSelected: lenderId
    })
})
.on(topup, (state) => {
  return initialState.copy({
    ...state,
    showingTransactionModal: false
  })
})

// SIDE EFFECTS
onSuccess(topup, ({ store: { dispatch } }) => {
  // to refresh transaction data after success topup
  dispatch(push('/transaction'));
});

onSuccess(withdraw, ({ store: { dispatch } }) => {
  // to refresh transaction data after success withdraw/cashout
  dispatch(push('/transaction'));
});
